// Mixins
import AppPage from '../../mixins/app-page'

// Utils
import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'
import { arraysHaveTheSameValues } from '../../utils/Array'

export default
{
    name: 'page-case',

    mixins:
    [
        AppPage
    ],

    data()
    {
        return {
            c: this.contentPage.case,
            slug: this.$route.params.slug,
            activeVideosID: [],
            videosCanBePlayed: []
        }
    },

    watch:
    {
        contentPage: 'onContentPageChange'
    },

    created()
    {
        this.c = this.c.is_published ? this.c : null
        // Get events
        this.eventHub.$on('window:resize', this._onResize)
        this.eventHub.$on('window:raf', this._onEnterFrame)
    },

    mounted()
    {
        this.eventHub.$emit('app-header:hide-filter')
        this.eventHub.$emit('app-header:change-color', 'black')
        this.eventHub.$emit('page:enable-scroll')
        this.eventHub.$emit('app-header:show-header')

        this._getDOMElements()

        this._onResize()

        this.loadVideos()
    },

    destroyed()
    {
        // Destroy events
        this.eventHub.$off('window:resize', this._onResize)
        this.eventHub.$off('window:raf', this._onEnterFrame)
    },

    methods:
    {
        // WATCHERS
        onContentPageChange()
        {
            this.c = null
            this.c = this.contentPage.case
            this.c = this.c.is_published ? this.c : null

            this._getDOMElements()
            this._onResize()

            this.loadVideos()
        },

        // EVENTS
        _onResize()
        {
            if (this.$images)
            {
                this._imagesRect = []

                for (let i = 0; i < this.$images.length; i += 1)
                {
                    this.$images[i].onload = () =>
                    {
                        this._imagesRect[i] = getAbsoluteBoundingRect(this.$images[i])

                        if (this.allImagesAreLoaded()
                            && this.$videos)
                        {
                            this._videosRect = []

                            for (let j = 0; j < this.$videosContainer.length; j += 1)
                            {
                                this._videosRect[j] = getAbsoluteBoundingRect(this.$videosContainer[j])
                            }
                        }
                    }
                }
            }
        },

        loadVideos()
        {
            for (let i = 0; i < this.$videos.length; i += 1)
            {
                const video = this.$videos[i]
                const index = parseInt(video.getAttribute('data-index'), 10)
                video.src = ''

                const xhr = new XMLHttpRequest()
                xhr.open('GET', this.$root.CONFIG.env.uploads + this.c.medias[index].value.file.path, true)
                xhr.responseType = 'blob'

                xhr.onload = () =>
                {
                    if (xhr.status === 200)
                    {
                        this.videosCanBePlayed.push(index)
                        video.src = URL.createObjectURL(xhr.response)
                    }
                }

                xhr.send()
            }
        },

        _onEnterFrame()
        {
            this._getActiveVideos()
        },

        // GETTERS
        allImagesAreLoaded()
        {
            return this.$images.length === this._imagesRect.length
        },

        _getDOMElements()
        {
            this.$videos = this.$el.querySelectorAll('.js-case-video')
            this.$videosContainer = this.$el.querySelectorAll('.js-case-video-container')
            this.$images = this.$el.querySelectorAll('.js-case-image')
        },

        _getActiveVideos()
        {
            if (this._videosRect
                && this._videosRect.length > 0)
            {
                const activeVideosIDBackUp = this.activeVideosID.splice(0)

                let thereIsActiveVideos = false
                for (let i = 0; i < this._videosRect.length; i += 1)
                {
                    const video = this._videosRect[i]

                    if (video
                        && this.$root.smoothScroll + this.$root.height >= video.top
                        && this.$root.smoothScroll <= video.top + video.height)
                    {
                        if (this.activeVideosID.indexOf(i) === -1)
                        {
                            this.activeVideosID.push(i)
                        }

                        thereIsActiveVideos = true
                    }
                    else if (this.activeVideosID.indexOf(i) !== -1)
                    {
                        this.activeVideosID.splice(this.activeVideosID.indexOf(i), 1)
                    }
                }

                if (!thereIsActiveVideos) this.activeVideosID = []

                this.activeVideosID = this.activeVideosID.sort()

                if (!arraysHaveTheSameValues(activeVideosIDBackUp, this.activeVideosID))
                {
                    this._playActiveCasesVideos()
                }
            }
        },

        // ACTIONS
        _playActiveCasesVideos()
        {
            if (this.$videos.length > 0
                && !this.$root.isTouch)
            {
                for (let i = 0; i < this.$videos.length; i += 1)
                {
                    const video = this.$videos[i]
                    const index = parseInt(video.getAttribute('data-index'), 10)

                    if (this.videosCanBePlayed.indexOf(index) !== -1)
                    {
                        if (this.activeVideosID.indexOf(i) !== -1)
                        {
                            video.play()
                        }
                        else if (!video.paused)
                        {
                            video.pause()
                        }
                    }
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-case/script.js